import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import analytics from '../utils/analytics';
import { getStoredReferralCode, clearStoredReferralCode } from '../utils/qrReferral';
import { useAuth } from '../contexts/AuthContext';

function QRLanding() {
  const navigate = useNavigate();
  const { currentUser: user } = useAuth();
  const [referralCode, setReferralCode] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('ref');

    if (code) {
      setReferralCode(code);
      
      // Track QR code scan
      analytics.trackQRCodeScan(code);
      
      // Store referral code for registration conversion (use consistent key)
      localStorage.setItem('referralCodeUsed', code);
      
      // Instant redirect based on auth status
      if (user) {
        // Already logged in - go to main app
        navigate('/app');
      } else {
        // Not logged in - go to marketing landing page
        navigate('/');
      }
    } else {
      // No referral code, redirect immediately based on auth
      if (user) {
        navigate('/app');
      } else {
        navigate('/');
      }
    }
  }, [navigate, user]);

  return (
    <div className="qr-landing">
      <div className="qr-redirect-container">
        <div className="qr-loading">
          <div className="loading-spinner"></div>
          <h1>🚽 CrapperMapper</h1>
          <p>Redirecting...</p>
          {referralCode && (
            <p className="referral-info">Referral code saved</p>
          )}
        </div>
      </div>

      <style jsx>{`
        .qr-landing {
          min-height: 100vh;
          background: #5752e8;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
        }

        .qr-redirect-container {
          background: white;
          border-radius: 16px;
          padding: 40px;
          max-width: 400px;
          width: 100%;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
          text-align: center;
        }

        .qr-loading h1 {
          color: #231F20;
          font-size: 2rem;
          margin-bottom: 20px;
        }

        .qr-loading p {
          color: #666;
          margin-bottom: 10px;
          font-size: 1.1rem;
        }

        .referral-info {
          color: #2d6657 !important;
          font-weight: bold;
          margin-top: 20px;
        }

        .loading-spinner {
          width: 40px;
          height: 40px;
          border: 4px solid rgba(87, 82, 232, 0.3);
          border-top: 4px solid #5752e8;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 30px;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @media (max-width: 768px) {
          .qr-redirect-container {
            padding: 30px 20px;
          }

          .qr-loading h1 {
            font-size: 1.5rem;
          }
        }
      `}</style>
    </div>
  );
}

export default QRLanding;
